export { BELOW_LIMIT, APPROACHING_LIMIT, TOUCHING_LIMIT, LIMITED } from '../_internal/constants/LimitStatus';